import { useId } from 'react';
import { Checkbox as CustomCheckbox } from 'primereact/checkbox';
import { CheckboxProps } from './Checkbox.types';
const Checkbox: React.FC<CheckboxProps> = ({
  checkboxStyle = '',
  onClick,
  value,
  checked,
  label,
}) => {
  const id = useId();
  return (
    <div className="flex gap-3 mt-2">
      <div
        className={`flex  items-center justify-center w-6 h-6 border-[2px] mb-3 border-solid rounded-[5px] cursor-pointer ${
          checked ? 'border-white p-1' : 'bg-transparent border-white'
        } ${checkboxStyle}`}
        onClick={onClick}
      >
        <CustomCheckbox
          unstyled
          inputId={`${id}-checkbox`}
          checked={checked}
          name={value}
          className="hidden"
        />
        {checked && (
          <i className="pi pi-check text-[#4AB58E] text-sm font-bold" />
        )}
      </div>
      {label && (
        <label htmlFor={`${id}-checkbox`} className="text-white">
          {label}
        </label>
      )}
    </div>
  );
};
export default Checkbox;
